import React from 'react';
import './error-page.css';
import { useNavigate } from 'react-router-dom';

function ErrorPage() {
    const navigate=useNavigate()
    return (
        <div className='error-page'>

            <div className='error-page-container'>
                <h1 className='error-page__title'> Opps! Page not found</h1>
                <p className='error-page__sub-title'> Maybe you can find something interesting on the home page!</p>
                <button className='error-page-btn app-btn-1'
                onClick={()=>{
                    (window.location.host?.toLowerCase()?.includes("careerlauncher")?
                    (window.location.href =
              "https://myzone.careerlauncher.com/mba/sis/test.jsp")
                    :navigate("/website"))
                }}
                
                >
                    Go to home page
                </button>
            </div>

        </div>
    )
}

export default ErrorPage